// 웨이터 호출 유틸리티 함수

import { logger } from '@/utils/logger';

// 클립보드 복사 유틸리티
export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    // Try modern clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    } else {
      // Fallback for browsers where Clipboard API is blocked
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        return successful;
      } catch (fallbackErr) {
        console.error('Fallback copy failed:', fallbackErr);
        return false;
      } finally {
        document.body.removeChild(textArea);
      }
    }
  } catch (err) {
    console.error('Failed to copy:', err);
    return false;
  }
}

// 운영체제별 WiFi 연결 안내 메시지 생성
export function getWifiConnectionMessage(wifiSSID: string, wifiPassword: string): string {
  const userAgent = navigator.userAgent.toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(userAgent);
  const isAndroid = /android/.test(userAgent);

  if (isIOS) {
    return `WiFi 정보가 복사되었습니다!\n\n설정 > WiFi로 이동하여\n"${wifiSSID}" 네트워크를 선택하고\n비밀번호를 붙여넣기 하세요.`;
  } else if (isAndroid) {
    return `WiFi 정보가 복사되었습니다!\n\n설정 > WiFi로 이동하여\n"${wifiSSID}" 네트워크를 선택하고\n비밀번호를 붙여넣기 하세요.`;
  } else {
    return `WiFi 정보가 복사되었습니다!\n\n네트워크: ${wifiSSID}\n비밀번호: ${wifiPassword}\n\nWiFi 설정에서 연결하세요.`;
  }
}
